export const FIND_ADDRESS = "FIND_ADDRESS";
export const FOUND_ADDRESS = "FOUND_ADDRESS";
export const ADDRESS_NOT_FOUND = "ADDRESS_NOT_FOUND";
export const FIND_GPS_COORDINATE = "FIND_GPS_COORDINATE";
export const FOUND_GPS_COORDINATE = "FOUND_GPS_COORDINATE";
export const GPS_COORDINATES_NOT_FOUND = "GPS_COORDINATE_NOT_FOUND";
export const DISABLE_NOTIFICATION = "DISABLE_NOTIFICATION";
export const SET_FIBRE_AVAILABILITY = "SET_FIBRE_AVAILABILTY";
export const MAP_CLICK = "MAP_CLICK";